// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Home/Content/Tasks/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Content_Home_Content_Tasks(
  $user_id: uuid!
  $view: String!
  $location_id: uuid!
  $filters: jsonb
) {
  tasks_get_dashboard(
    user_id: $user_id
    view: $view
    location_id: $location_id
    filters: $filters
  ) {
    id
    patient_name
    task {
      id
      title
      priority
      due_date
      assignees {
        id
        user_id
        user {
          id
          vaxiom_person {
            id
            _id
            first_name
            last_name
          }
        }
      }
      patients {
        id
        _id
        person {
          id
          first_name
          last_name
        }
      }
      board_id
      board {
        id
        name
        metadata
        stages {
          id
          text: name
          done
        }
      }
      stage {
        id
        name
      }
    }
    comments_aggregate_count
    logs_aggregate_count
  }
}

`